import { io, Socket } from 'socket.io-client';
import { REACT_APP_API_BASE_URL } from '../../config/env';

export type AmbulanceLocationPayload = {
  bookingId?: string;
  driverId?: string;
  latitude?: number;
  longitude?: number;
  heading?: number | null;
  speed?: number | null;
  accuracy?: number | null;
  timestamp?: string;
};

function socketServerUrl(): string {
  const apiRoot = (REACT_APP_API_BASE_URL || '').trim().replace(/\/+$/, '');
  if (!apiRoot || apiRoot.startsWith('/')) return window.location.origin;
  return apiRoot.replace(/\/api$/i, '') || apiRoot;
}

export function connectAmbulanceTrackingSocket(token: string): Socket {
  return io(socketServerUrl(), {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
  });
}

export function registerMasterAdminSocket(
  socket: Socket,
  token: string
): Promise<{ success: boolean; message?: string; adminId?: string }> {
  return new Promise((resolve) => {
    socket.emit('registerMasterAdmin', { token }, (ack: { success?: boolean; message?: string; adminId?: string }) => {
      resolve({
        success: Boolean(ack?.success),
        message: ack?.message,
        adminId: ack?.adminId,
      });
    });
  });
}

export function joinBookingTrackingSocket(
  socket: Socket,
  bookingId: string
): Promise<{
  success: boolean;
  message?: string;
  trackingActive?: boolean;
  hasActiveLocation?: boolean;
  currentLocation?: {
    trackingActive?: boolean;
    latitude?: number | null;
    longitude?: number | null;
    updatedAt?: string | null;
  };
}> {
  return new Promise((resolve) => {
    socket.emit('joinBookingTracking', { bookingId }, (ack: Record<string, unknown>) => {
      resolve({
        success: Boolean(ack?.success),
        message: typeof ack?.message === 'string' ? ack.message : undefined,
        trackingActive: Boolean(ack?.trackingActive),
        hasActiveLocation: Boolean(ack?.hasActiveLocation),
        currentLocation: ack?.currentLocation as {
          trackingActive?: boolean;
          latitude?: number | null;
          longitude?: number | null;
          updatedAt?: string | null;
        },
      });
    });
  });
}

export function leaveBookingTrackingSocket(socket: Socket, bookingId: string): void {
  socket.emit('leaveBookingTracking', { bookingId });
}
